export const ENGLISH_LEVELS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')

export const CEFR_SUB_TITLES = {
  A1: 'Iniciante',
  A2: 'Básico',
  B1: 'Intermediário',
  B2: 'Intermediário avançado',
  C1: 'Avançado',
  C2: 'Proficiente'
}
